import { Button, Checkbox, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
// import SaveProductButton from "./SaveProductButton";
import { useRecordContext } from "react-admin";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";
import { NoContentSet } from "./NoContentSet";

export default function Community({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const data = record?.data?.basic?.community;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;
  const [showDetail, setShowDetail] = React.useState(true);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        affiliation: data?.sAffiliation || [],
        communityZip: data?.communityZip || "",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "community";
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id="section_community">
      <SectionTitle title="Community - Set requirements if the applicant is required to part of intended community" />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Grid container spacing={2}>
          {/* <Button
            variant="text"
            color="primary"
            sx={{ textTransform: "none", mt: 1, ml: 1, mb: 2 }}
            onClick={() => setShowDetail(!showDetail)}
          >
            Community Affiliation Requirement
          </Button> */}
          {productModulesGroup?.includes("affiliation") ? (
            <Grid item xs={12} container spacing={1}>
              {showDetail && (
                <>
                  <Typography>
                    Select Permissible Types of Affiliation
                  </Typography>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes("live")}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedValues, "live"]
                                : selectedValues.filter((v) => v !== "live");
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Live
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes("work")}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedValues, "work"]
                                : selectedValues.filter((v) => v !== "work");
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Work
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes("study")}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedValues, "study"]
                                : selectedValues.filter((v) => v !== "study");
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Study
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes("volunteer")}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedValues, "volunteer"]
                                : selectedValues.filter(
                                    (v) => v !== "volunteer"
                                  );
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Volunteer
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes("worship")}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedValues, "worship"]
                                : selectedValues.filter((v) => v !== "worship");
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Worship
                  </Grid>
                  <Grid item xs={12}>
                    <Controller
                      name="affiliation"
                      control={control}
                      render={({ field }) => {
                        const selectedValues = field.value || [];
                        return (
                          <Checkbox
                            checked={selectedValues.includes(
                              "financial_education_program"
                            )}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [
                                    ...selectedValues,
                                    "financial_education_program",
                                  ]
                                : selectedValues.filter(
                                    (v) => v !== "financial_education_program"
                                  );
                              field.onChange(newValue);
                            }}
                            size="small"
                            color="primary"
                          />
                        );
                      }}
                    />
                    Financial Education Program
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      Enter ZIP Codes Defining the Community. Do not use space
                      or characters to separate the ZIP codes. ZIP codes are
                      automatically separated by”,”.
                    </Typography>
                    <Controller
                      name="communityZip"
                      control={control}
                      render={({ field }) => (
                        <CustomProductTextField
                          {...field}
                          label="ZIP Codes"
                          fullWidth
                          rows={2}
                          multiline={true}
                          variant="outlined"
                          placeholder="Text (512 Char Limit)"
                        />
                      )}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          ) : (
            <NoContentSet />
          )}
        </Grid>
      </Box>
      {/* Form Actions */}
      {productModulesGroup?.includes("affiliation") && (
        <CustomProductActionBottom>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveClick}
            disabled={!isDirty}
            sx={{ width: "120px", mt: 1 }}
          >
            Save
          </Button>
        </CustomProductActionBottom>
      )}
    </SectionStyled>
  );
}
